import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export interface SyncCheckoutStatusResponse {
	paymentStatus: string | null;
}

export const useSyncCheckoutStatus = () => {
	return useMutation({
		mutationFn: async () => {
			try {
				return (await api.post<SyncCheckoutStatusResponse>('/user/checkout-status/sync')).data;
			} catch (error) {
				throw toApiError(error, 'Erro ao verificar o status do pagamento');
			}
		},
		onError: (error) =>
			console.error(
				'Erro ao verificar o status do pagamento:',
				getApiErrorMessage(error, 'Erro ao verificar o status do pagamento')
			),
	});
};
